<div class="row">
  <div class="requestCOIOuter fixHeightMobile" (window:resize)="onresize($event)">

    <div class="request-coi-page">
      <div class="order-view-sec breadcrumbOuter padding-0" id="orderView1" [ngClass]="'col-md-12'">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb pl-0">
            <li class="breadcrumb-item active">
              <a href="javascript:void(0)" (click)="navigateToLandingPage()">Seed Replant</a>
              <i class="fas fa-angle-right"></i>
            </li>
            <li class="breadcrumb-item breadcrumbColor xs-pr-0">
              <span id="spnBreadcrum">{{breadcrumbtext}}</span>
            </li>
          </ol>
        </nav>
      </div>
      <div class="OrderReleaseTop">
        <div class="row p-3">
          <!--Sold To Select List-->
          <div class=" col-md-4 material-select arrow-remove withBordr" [class.cpp-create-soldTo]="!soldToAccount">
            <ng-select name="ddlSoldTo"
                       [items]="soldToAccountList"
                       class="custom-select-grower grower-add-drop pb-0"
                       [class.ng-select-disabled]="!soldToAccount"
                       [virtualScroll]="true"
                       [(ngModel)]="soldToAccount"
                       bindLabel="accountNameCityState"
                       [disabled]="true"
                       bindValue="accountNumber"
                       placeholder="Sold To: (Will Display after selection of Ship To):"
                       [loading]="soldToDataLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn">
              <ng-template ng-label-tmp let-item="item" let-index="index">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-12  mb-2" [ngClass]="{'acc-details': isEditMode}">
                      <div class="mb-0 mt-2">
                        {{item.accountName}}
                      </div>
                      <div class="mb-0">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </div>
                      <div class="mb-0">
                        {{item.primaryPhoneNumber}}
                      </div>
                      <div class="pb-2">
                        Account #: {{item.accountNumber}}
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

          <!--Ship To Select List-->
          <div class=" col-md-4 material-select withBordr" [ngClass]="{'arrow-remove': isEditMode}">
            <ng-select name="ddlShipTo"
                       [items]="shipToAccountList"
                       class="custom-select-grower grower-add-drop pb-0"
                       [virtualScroll]="true"
                       [(ngModel)]="shipToAccount"
                       bindLabel="accountNameCityState"
                       [disabled]="isEditMode || readOnlyAccess"
                       bindValue="accountNumber"
                       placeholder="Ship To: *"
                       [loading]="shipToDataLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       (change)="getShipTo($event)"
                       (clear)="getShipTo($event)">
              <ng-template ng-label-tmp let-item="item" let-index="index">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-12  mb-2" [ngClass]="{'acc-details': isEditMode}">
                      <div class="mb-0 mt-2">
                        {{item.accountName}}
                      </div>
                      <div class="mb-0">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </div>
                      <div class="mb-0">
                        {{item.primaryPhoneNumber}}
                      </div>
                      <div class="pb-2">
                        Account #: {{item.accountNumber}}
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

          <!--Credit To Select List-->
          <div class=" col-md-4 material-select withBordr" [class.cpp-create-soldTo]="!creditToAnotherLocation">
            <ng-select name="ddlCreditTo"
                       [items]="creditToList"
                       class="custom-select-grower pb-0 grower-add-drop"
                       [virtualScroll]="true"
                       [(ngModel)]="creditToAccount"
                       bindLabel="accountNameCityState"
                       bindValue="accountNumber"
                       [disabled]="(!creditToAnotherLocation || shipToAccount ==null || shipToAccount ==undefined || readOnlyAccess)"
                       placeholder="Credit to Account:"
                       [loading]="creditToDataLoading"
                       [closeOnSelect]="true"
                       [searchFn]="accountSearchFn"
                       (change)="getCreditTo($event)"
                       (clear)="getCreditTo($event)">
              <ng-template ng-label-tmp let-item="item" let-index="index">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-12  mb-2" [ngClass]="{'acc-details': isEditMode}">
                      <div class="mb-0 mt-2">
                        {{item.accountName}}
                      </div>
                      <div class="mb-0">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </div>
                      <div class="mb-0">
                        {{item.primaryPhoneNumber}}
                      </div>
                      <div class="pb-2">
                        Account #: {{item.accountNumber}}
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
            <div class="pt-1 checkbox-color">
              <mat-checkbox class="custom-checkbox"
                            [disabled]="readOnlyAccess || !shipToAccount"
                            [style.display]=""
                            [checked]="creditToAnotherLocation"
                            (change)="UpdateCreditToSelection($event.checked)"
                            (input)="hasHeaderInfoChanged('Credit Account');"
                            [indeterminate]=""
                            [(ngModel)]="creditToAnotherLocation"></mat-checkbox>
              To credit to a different account than the Ship To
            </div>
          </div>
        </div>
      </div>
      <div class="OrderReleaseTop">
        <div class="row p-3 pb-0 grower-add-dropDown">
          <!--Grower To Select List-->
          <div class="col-md-6 material-select">
            <ng-select name="ddlGrowerDetails"
                       [items]="growerList"
                       class="custom-select-grower grower-add-drop pb-0"
                       [(ngModel)]="growerGMK"
                       [virtualScroll]="true"
                       bindLabel="growerNameCityState"
                       placeholder="Grower:"
                       [loading]="growerLoading"
                       [readonly]="readOnlyAccess"
                       bindValue="gmk"
                       [searchFn]="growerSearchFn"
                       [closeOnSelect]="true"
                       (search)="search($event)"
                       (change)="onGrowerSelection($event)">
              <ng-template ng-label-tmp let-item="item" let-index="index">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-12  mb-2" [ngClass]="{'acc-details': isEditMode}">
                      <div class="mb-0 mt-2">
                        {{item.businessName?.toUpperCase()}}
                      </div>
                      <div class="mb-0">
                        {{item.address1?.toUpperCase()}},  {{item.city?.toUpperCase()}}, {{item.state?.toUpperCase()}} - {{item.zip}}
                      </div>
                      <div class="mb-0">
                        {{item.primaryPhoneNumber}}
                      </div>
                      <div class="pb-2">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Grower GMK: {{item.gmk}}
                        </span>
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Grower GLN: {{item.growerGLN}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row">
                    <div class="col-md-8">
                      <h4 class="name greenColor" [ngOptionHighlight]="search">
                        {{item.businessName?.toUpperCase()}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1?.toUpperCase()}},  {{item.city?.toUpperCase()}}, {{item.state?.toUpperCase()}} - {{item.zip}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Grower GMK: {{item.gmk}}
                        </span>
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Grower GLN: {{item.growerGLN}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
              <ng-template ng-footer-tmp let-search="searchTerm">
                <div class="custom-drop-footer">
                  <div class="row">
                    <div class="col-md-8">
                      <button mat-raised-button class="btns" color="primary" (click)="openGrowerSliderModel()">Advanced Search</button>
                    </div>
                    <div class="col-md-4 bold text-right">
                      Results : {{searchCount}}
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

          <!--Non subscribers Email-->
          <div class="col-md-3 padding-t10" *ngIf="isShowNonSubEmail">
            <mat-form-field class="wide100" [ngClass]="{valid : (isNotValid ==false)}">
              <mat-label>Non-Subscriber Email:</mat-label>
              <input matInput type="text" name="emailAddress" maxlength="500"
                     placeholder="(Separate multiple email addresses by a semi-colon)"
                     [(ngModel)]="emailAddress"
                     [readonly]="readOnlyAccess"
                     [pattern]="masterConstants.EMAIL_PATTERN"
                     (blur)="validateEmail()"
                     (input)="hasHeaderInfoChanged('Email Address');"
                     email="true">
              <mat-error *ngIf="isNotValid">
                This is invalid e-mail address(s). Separate multiple email addresses by a semi-colon.
              </mat-error>
            </mat-form-field>
          </div>
        </div>
      </div>

      <!--Failed Grid-->
      <div class="OrderReleaseTop mb-0 pt-2">
        <div class="row listing-action-items grower-page">
          <div class="col-xl-4 col-lg-4 col-md-4">
            <div>
              <p class="lead padding-t5 pad-left20" [ngClass]="{'pad-left120': (showTabs && !disablecheckbox), 'padding-l50': (!showTabs && !disablecheckbox && !readOnlyAccess)}"> Failed Product </p>
            </div>
            <mat-checkbox *ngIf="!disablecheckbox && !readOnlyAccess" #AllProductCheck class="custom-checkbox select-all-check padding-l10"
                          [checked]="isAllProductChecked"
                          [indeterminate]="checkBoxCount > 0 && !isAllProductChecked"
                          (change)="enableAllCheckBoxes(!isAllProductChecked, true)"
                          title="Select All Lines"></mat-checkbox>
            <div class="product-tools-tab" *ngIf="showTabs && !readOnlyAccess" appClickOutside (clickOutside)="tabNode=''">
              <div class="tab-bar">
                <ul>
                  <li (click)="showTab('delete')" [ngClass]="{'active': tabNode==='delete'}" class="seperator" matTooltip="Delete Failed Products" [matTooltipPosition]="'above'">
                    <i class="icon-ico-trash"></i>
                  </li>
                </ul>
              </div>
              <div class="tab-content">
                <div *ngIf="tabNode==='delete'" class="delete-product">
                  <div class="tab-content-heading">
                    For: {{shipToAccountName}}
                  </div>
                  <div class="tab-content-detail">
                    <p>Are you sure you want to delete <span> {{checkBoxCount}} </span> selected Items(s)?</p>
                    <div class="btn-area">
                      <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('delete',true)">Yes</button>
                      <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('delete',false)">No</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-8 col-lg-8">
            <div class="d-block d-sm-block xs-pl-10 xs-pr-10 text-right">
              <div class="display-ib wAuto">
                <mat-paginator #failedPaginator [pageSize]="50" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
              </div>
              <button *ngIf="!readOnlyAccess" mat-raised-button class="btns xs-button xs-full-width" [disabled]="!isAddProductEnable" (click)="addFailedProduct()" id="btnAddFailedProduct">Add Failed Product</button>
            </div>
          </div>
        </div>
      </div>
      <div class="OrderReleaseTop">
        <div class="row">
          <div class="col-md-12">
            <div class="tableContainer prodTableContainer failedTable" id="failedProductTbl">
              <table mat-table #requestTable [dataSource]="productItemsDataSource" multiTemplateDataRows class="matTables seedCropLossTable">

                <ng-container matColumnDef="{{column}}" *ngFor="let column of displayedColumns">
                  <div *ngIf="column=='checkbox'">
                  <th mat-header-cell *matHeaderCellDef></th>
            </div>

            <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th></div>
            <div *ngIf="column=='treatment'"><th mat-header-cell *matHeaderCellDef class="treatment text-center">Treatment</th></div>
            <div *ngIf="column=='lotNumber'"><th mat-header-cell *matHeaderCellDef class="lotNo text-center">Lot Number</th></div>
            <div *ngIf="column=='eligibleUnits'"><th mat-header-cell *matHeaderCellDef class="units lotNo text-center">Eligible Units</th></div>
            <div *ngIf="column=='unitsSoldToGrower'"><th mat-header-cell *matHeaderCellDef class="units soldTo text-center failedUnits">Units Sold To Grower</th></div>
            <div *ngIf="column=='failedUnits'"><th mat-header-cell *matHeaderCellDef class="dumpedLines soldTo text-center failedUnits">Failed Units</th></div>
            <div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="uom text-center">UOM</th></div>
            <div *ngIf="column=='problemDescription'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Description of the problem</th></div>
            <td mat-cell *matCellDef="let element" id="failedProductTbl_error_{{element.lineErrors.itemId}}_{{element.lineErrors.lotNumber}}">
              <div *ngIf="column=='checkbox'">
                <div class="lineitem-symbols"></div>
              </div>
              <div *ngIf="column=='checkbox' && !readOnlyAccess && isAddProductEnable" class="text-center" matTooltip="Select Product" [matTooltipPosition]="'above'">

                <mat-checkbox *ngIf="!readOnlyAccess" #SingleCheck
                              (change)="enableCheckBoxSingle(SingleCheck._checked, true); element.isSelected=SingleCheck._checked;"
                              [(ngModel)]="element.isSelected"
                              class="custom-checkbox"></mat-checkbox>
              </div>

              <div *ngIf="column=='product'" class="order-info-outer">
                <div class="order-info">
                  <p class="prod-id">{{element.itemVendorName}}</p>
                  <p class="prod-name" matTooltip="{{element.itemNumber}}" [matTooltipPosition]="'above'">{{element.itemDescription}}</p>
                </div>
              </div>

              <div *ngIf="column=='treatment'" class="measureUnit text-center font-14">
                <p class="mb-0"> {{ element.treatmentDescription }} </p>
              </div>

              <div *ngIf="column=='lotNumber'" class="measureUnit text-center font-14">
                <p class="mb-0"> {{element.lotNumber}} </p>
              </div>

              <div *ngIf="column=='eligibleUnits'" class="measureUnit text-center font-14">
                <p class="mb-0"> {{element.eligibleUnits}} </p>
              </div>

              <div *ngIf="column=='unitsSoldToGrower'" class="quantityBlock text-center">
                <div>
                  <button *ngIf="!readOnlyAccess" [disabled]="element.isDecreaseQtyDisable" class="plus-minus-btn minusBtn" (click)="unitChange('decrease',element,'unitsPurchased', true)"> - </button>
                  <input id="txtUnitsSoldToGrower_{{element.itemNumber}}" [readonly]="readOnlyAccess" [disabled]="element.isDecreaseQtyDisable || element.isIncreaseQtyDisable" type="text" class="geu-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element, 'unitsPurchased', true)" [(ngModel)]="element.unitsPurchased" maxlength="5" NumbersOnly [ngClass]="{'invalid-txt': (element.dumpedUnits==0 || element.dumpedUnits=='')}" />
                  <button *ngIf="!readOnlyAccess" [disabled]="element.isIncreaseQtyDisable" class="plus-minus-btn plusBtn" (click)="unitChange('increase',element,'unitsPurchased', true)"> + </button>
                </div>
              </div>

              <div *ngIf="column=='failedUnits'" class="quantityBlock text-center">
                <div>
                  <button *ngIf="!readOnlyAccess" [disabled]="element.isFailedUnitsDecreaseQtyDisable" class="plus-minus-btn minusBtn" (click)="unitChange('decrease',element,'unitsFailed', true)"> - </button>
                  <input id="txtFailedUnits_{{element.itemNumber}}" [readonly]="readOnlyAccess" [disabled]="element.isFailedUnitsDecreaseQtyDisable || element.isFailedUnitsIncreaseQtyDisable" type="text" class="geu-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element, 'unitsFailed', true)" [(ngModel)]="element.unitsFailed" maxlength="5" NumbersOnly [ngClass]="{'invalid-txt': (element.dumpedUnits==0 || element.dumpedUnits=='')}" />
                  <button *ngIf="!readOnlyAccess" [disabled]="element.isFailedUnitsIncreaseQtyDisable" class="plus-minus-btn plusBtn" (click)="unitChange('increase',element,'unitsFailed', true)"> + </button>
                </div>
              </div>

              <div *ngIf="column=='uom'" class="measureUnit text-center font-14">
                <p class="mb-0"> {{element.uom}} </p>
              </div>

              <div *ngIf="column=='problemDescription'" class="measureUnit text-center">
                <textarea id="txtProblemDescription_{{element.itemNumber}}" [readonly]="readOnlyAccess" type="text" class="notesTxt" [(ngModel)]="element.problemDescription" maxlength="200" (input)="hasInputTextChanged(element, true);"></textarea>
              </div>
            </td>
            </ng-container>

            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <ng-container matColumnDef="expandedDetail">
              <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="displayedColumns.length">
                <div class="seller-info">
                  <div class="row" *ngIf="IsShowTreatment(element)">
                    <div class="col-4 seller-name padding-r10" [ngClass]="{'padding-l40': IsShowTreatment(element) }">Original Grower Invoice#:</div>
                    <div class="col-2 seller-name padding-r10 text-left">Original Planting Date:</div>
                    <div class="col-2 customer-po text-left padding-r10">Grower License#:</div>
                    <div class="col-2 customer-po">
                      Treatment:
                    </div>
                    <div class="col-2 customer-po text-left">
                      OtherTreatment:
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4 text-left padding-l40">
                      <span class="seller-name padding-r10 font-11" *ngIf="!IsShowTreatment(element)">Original Grower Invoice#:</span>
                      <span class="customer-po-input inVoiceInput" [ngClass]="{'padding-b5': IsShowTreatment(element) }">
                        <mat-form-field class="example-full-width">
                          <input id="txtGrowerInvoice_{{element.itemNumber}}" matInput [readonly]="readOnlyAccess" type="text" [(ngModel)]="element.growerInvoice" maxlength="20" (input)="hasInputTextChanged(element, true);" autocomplete="new-username">
                        </mat-form-field>
                      </span>
                    </div>
                    <div class="col-2 ">
                      <span class="seller-name padding-r10 text-left font-11" *ngIf="!IsShowTreatment(element)">Original Planting Date:</span>
                      <span class="text-center deliveryDatePicker" [ngClass]="{'handCursor': !readOnlyAccess }">
                        <mat-form-field>
                          <input id="txtPlantingDate_{{element.itemNumber}}" readonly (click)="picker.open();" matInput [matDatepicker]="picker" [(ngModel)]="element.plantingDate" #dateName="ngModel" maxlength="12" [min]="getEffectiveInvoiceDate(true, element)" [max]="getEffectiveInvoiceDate(false, element)" [ngClass]="{'handCursor': !readOnlyAccess }"
                                 name="dateName" oninput="this.value=this.value.replace(/[^0-9/]/g,'');" (dateChange)="hasInputTextChanged(element, true)"
                                 autocomplete="new-username">
                          <mat-datepicker-toggle matSuffix [for]="picker" [readonly]="readOnlyAccess"></mat-datepicker-toggle>
                          <mat-datepicker #picker [disabled]="readOnlyAccess">
                          </mat-datepicker>
                        </mat-form-field>
                      </span>
                    </div>
                    <div class="col-2" [ngClass]="{'col-md-4': !IsShowTreatment(element) }">
                      <span class="customer-po text-left padding-r10 font-11" *ngIf="!IsShowTreatment(element)">
                        Grower License#:
                      </span>
                      <span class="customer-po-input" [ngClass]="{'padding-b5': IsShowTreatment(element) }">
                        {{element.licenseNumber}}
                        <!--<mat-form-field class="example-full-width">-->
                        <!--<input id="txtLicenseNumber_{{element.itemNumber}}" matInput [readonly]="readOnlyAccess" type="text" [(ngModel)]="element.licenseNumber" maxlength="50" (input)="hasInputTextChanged(element, true);" autocomplete="new-username" [readonly]="vendersArr.includes(element.vendorName) && element.licenseStatus === 'L'">-->
                        <!--<input id="txtLicenseNumber_{{element.itemNumber}}" matInput type="text" [(ngModel)]="element.licenseNumber" maxlength="50" (input)="hasInputTextChanged(element, true);" autocomplete="new-username" [readonly]="true">
              </mat-form-field>-->
                      </span>
                    </div>
                    <div class="col-2  material-select reason-dropdown treatment-dropdown margin-top-27" *ngIf="IsShowTreatment(element)">
                      <ng-select [items]="treatmentList"
                                 class="change-dropdown"
                                 [virtualScroll]="true"
                                 [(ngModel)]="element.replantTreatment"
                                 bindLabel="description"
                                 bindValue="treatmentId"
                                 appendTo=".failedTable"
                                 [selectOnTab]="true"
                                 [clearable]="false"
                                 [searchable]="false"
                                 [closeOnSelect]="true"
                                 (change)="hasInputTextChanged(element, true);"
                                 [attr.id]="'ddlTreatment_' + element.itemNumber">
                        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                          <div class="dropdown-template" [attr.id]="'ddlTreatmentOpt_'+element.itemNumber+'_'+item.treatmentId">
                            <div class="row">
                              <div class="col-md-8">
                                <p class="name greenColor treatmentFont mb-0" [ngOptionHighlight]="search">
                                  {{item.description}}
                                </p>
                              </div>
                            </div>
                          </div>
                        </ng-template>
                      </ng-select>
                    </div>
                    <div class="col-1" *ngIf="IsShowTreatment(element)">
                      <div class="customer-po-input inVoiceInput" [ngClass]="{'padding-b5': IsShowTreatment(element) }">
                        <mat-form-field class="example-full-width">
                          <input id="txtOtherTreatment_{{element.itemNumber}}" matInput type="text" [(ngModel)]="element.otherTreatment" maxlength="30" (input)="hasInputTextChanged(element, true);" autocomplete="new-username">
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="inline-error" *ngIf="isReview && element.lineErrors && element.lineErrors.errors.length > 0">
                  <div class="row">
                    <div class="col-md-9">
                      <ol class="error-list">
                        <li *ngFor="let err of element.lineErrors.errors">
                          {{err.error}}
                      </ol>
                    </div>
                    <div class="col-md-3 revertToPrev" (click)="revertToPreviousError(element, true)">
                      <span>
                        Revert to Previous.
                        <i class="icon-ico-Reply"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;"
                class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
                (click)="expandedElement = expandedElement === element ? null : element"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
            <div *ngIf="productItemsDataSource == undefined || productItemsDataSource?.data.length == 0" class="noDataMsg">
              <p>No Record Found.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--Replant Grid-->
    <div class="OrderReleaseTop mb-0 pt-2">
      <div class="row listing-action-items grower-page">
        <div class="col-xl-4 col-lg-4 col-md-4">
          <div>
            <p class="lead padding-t5 pad-left20" [ngClass]="{'pad-left120': (showTabsReplant && !disablecheckboxReplant), 'padding-l50': (!showTabsReplant && !disablecheckboxReplant && !readOnlyAccess)}"> Replant Product </p>
          </div>
          <mat-checkbox *ngIf="!disablecheckboxReplant && !readOnlyAccess" #AllProductCheck class="custom-checkbox select-all-check padding-l10"
                        [checked]="isAllReplantProductChecked"
                        [indeterminate]="checkBoxCountReplant > 0 && !isAllReplantProductChecked"
                        (change)="enableAllCheckBoxes(!isAllReplantProductChecked, false)"
                        title="Select All Lines"></mat-checkbox>
          <div class="product-tools-tab" *ngIf="showTabsReplant && !readOnlyAccess" appClickOutside (clickOutside)="tabNodeReplant=''">
            <div class="tab-bar">
              <ul>
                <li (click)="showTabReplant('deleteReplant')" [ngClass]="{'active': tabNodeReplant==='deleteReplant'}" class="seperator" matTooltip="Delete Replant Products" [matTooltipPosition]="'above'">
                  <i class="icon-ico-trash"></i>
                </li>
              </ul>
            </div>
            <div class="tab-content">
              <div *ngIf="tabNodeReplant==='deleteReplant'" class="delete-product">
                <div class="tab-content-heading">
                  For: {{shipToAccountName}}
                </div>
                <div class="tab-content-detail">
                  <p>Are you sure you want to delete <span> {{checkBoxCountReplant}} </span> selected Items(s)?</p>
                  <div class="btn-area">
                    <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('deleteReplant',true)">Yes</button>
                    <button mat-raised-button class="btns submitBtns large-btns" color="primary" (click)="setAllFields('deleteReplant',false)">No</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 col-lg-8">
          <div class="d-block d-sm-block xs-pl-10 xs-pr-10 text-right">
            <div class="display-ib wAuto">
              <mat-paginator #replantPaginator [pageSize]="50" [pageSizeOptions]="masterConstants.PAGE_SIZE_OPTIONS"></mat-paginator>
            </div>
            <button *ngIf="!readOnlyAccess" mat-raised-button class="btns xs-button xs-full-width" [disabled]="!isAddProductEnable" (click)="addReplantProduct()" id="btnAddReplantProduct">Add Replant Product</button>
          </div>
        </div>
      </div>
    </div>
    <div class="OrderReleaseTop">
      <div class="row">
        <div class="col-md-12">
          <div class="tableContainer prodTableContainer replantTable" id="replantProductTbl">
            <table mat-table #requestTable [dataSource]="replantProductItemsDataSource" multiTemplateDataRows class="matTables seedCropLossTable">

              <ng-container matColumnDef="{{column}}" *ngFor="let column of replantDisplayedColumns">
                <div *ngIf="column=='checkbox'">
                <th mat-header-cell *matHeaderCellDef></th>
          </div>

          <div *ngIf="column=='product'"><th mat-header-cell *matHeaderCellDef class="prodNameBlock">Product</th></div>
          <div *ngIf="column=='treatment'"><th mat-header-cell *matHeaderCellDef class="treatment text-center">Treatment</th></div>
          <div *ngIf="column=='lotNumber'"><th mat-header-cell *matHeaderCellDef class="lotNo text-center">Lot Number</th></div>
          <div *ngIf="column=='eligibleUnits'"><th mat-header-cell *matHeaderCellDef class="lotNo units text-center">Eligible Units</th></div>
          <div *ngIf="column=='unitsSoldToGrower'"><th mat-header-cell *matHeaderCellDef class="units soldTo text-center failedUnits"></th></div>
          <div *ngIf="column=='unitsCredited'"><th mat-header-cell *matHeaderCellDef class="soldTo dumpedLines text-center failedUnits">Replant Units</th></div>
          <div *ngIf="column=='uom'"><th mat-header-cell *matHeaderCellDef class="uom text-center">UOM</th></div>
          <div *ngIf="column=='problemDescription'"><th mat-header-cell *matHeaderCellDef class="notes text-center">Customer Notes</th></div>
          <td mat-cell *matCellDef="let element" id="replantProductTbl_error_{{element.lineErrors.itemId}}_{{element.lineErrors.lotNumber}}">

            <div *ngIf="column=='checkbox'">
              <div class="lineitem-symbols"></div>
            </div>
            <div *ngIf="column=='checkbox' && !readOnlyAccess && isAddProductEnable" class="text-center" matTooltip="Select Product" [matTooltipPosition]="'above'">

              <mat-checkbox *ngIf="!readOnlyAccess" #SingleCheck
                            (change)="enableCheckBoxSingle(SingleCheck._checked, false); element.isSelected=SingleCheck._checked;"
                            [(ngModel)]="element.isSelected"
                            class="custom-checkbox"></mat-checkbox>
            </div>

            <div *ngIf="column=='product'" class="order-info-outer">
              <div class="order-info">
                <p class="prod-id">{{element.itemVendorName}}</p>
                <p class="prod-name" matTooltip="{{element.itemNumber}}" [matTooltipPosition]="'above'">{{element.itemDescription}}</p>
              </div>
            </div>

            <div *ngIf="column=='treatment'" class="measureUnit text-center font-14">
              <p class="mb-0"> {{ element.treatmentDescription }} </p>
            </div>

            <div *ngIf="column=='lotNumber'" class="measureUnit text-center  font-14">
              <p class="mb-0"> {{element.lotNumber}} </p>
            </div>

            <div *ngIf="column=='eligibleUnits'" class="measureUnit text-center  font-14">
              <p class="mb-0"> {{element.eligibleUnits}} </p>
            </div>
            <div *ngIf="column=='unitsSoldToGrower'" class="quantityBlock text-center">
              <p class="mb-0">&nbsp; </p>
            </div>
            <div *ngIf="column=='unitsCredited'" class="quantityBlock text-center">
              <div>
                <button *ngIf="!readOnlyAccess" [disabled]="element.isUnitsCreditedDecreaseQtyDisable" class="plus-minus-btn minusBtn" (click)="unitChange('decrease',element,'unitsCredited', false)"> - </button>
                <input id="txtUnitsCredited_{{element.itemNumber}}" [readonly]="readOnlyAccess" [disabled]="element.isUnitsCreditedDecreaseQtyDisable || element.isUnitsCreditedIncreaseQtyDisable" type="text" class="geu-txt unitsText largeTableTxt" (keyup)="quantityTextChange(element, 'unitsCredited', false)" [(ngModel)]="element.unitsCredited" maxlength="5" NumbersOnly [ngClass]="{'invalid-txt': (element.dumpedUnits==0 || element.dumpedUnits=='')}" />
                <button *ngIf="!readOnlyAccess" [disabled]="element.isUnitsCreditedIncreaseQtyDisable" class="plus-minus-btn plusBtn" (click)="unitChange('increase',element,'unitsCredited', false)"> + </button>
              </div>
            </div>

            <div *ngIf="column=='uom'" class="measureUnit text-center  font-14">
              <p class="mb-0"> {{element.uom}} </p>
            </div>

            <div *ngIf="column=='problemDescription'" class="measureUnit text-center">
              <textarea id="txtCustomerNotes_{{element.itemNumber}}" [readonly]="readOnlyAccess" type="text" class="notesTxt" [(ngModel)]="element.problemDescription" maxlength="200" (input)="hasInputTextChanged(element, false);"></textarea>
            </div>
          </td>
          </ng-container>

          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell class="product-details" *matCellDef="let element" [attr.colspan]="replantDisplayedColumns.length">
              <div class="seller-info">
                <div class="row" *ngIf="IsShowTreatment(element)">
                  <div class="col-4 seller-name padding-r10" [ngClass]="{'padding-l40': IsShowTreatment(element) }">Replant Grower Invoice#:</div>
                  <div class="col-2 seller-name padding-r10 text-left">Replant Date:</div>
                  <div class="col-2 customer-po text-left padding-r10">Grower License#:</div>
                  <div class="col-2 customer-po">
                    Treatment:
                  </div>
                  <div class="col-2 customer-po text-left">
                    OtherTreatment:
                  </div>
                </div>
                <div class="row">
                  <div class="col-4 text-left padding-l40">
                    <span class="seller-name padding-r10" *ngIf="!IsShowTreatment(element)">Replant Grower Invoice#:</span>
                    <span class="customer-po-input inVoiceInput" [ngClass]="{'padding-b5': IsShowTreatment(element) }">
                      <mat-form-field class="example-full-width">
                        <input id="txtReplantGrowerInvoice_{{element.itemNumber}}" matInput [readonly]="readOnlyAccess" type="text" [(ngModel)]="element.growerInvoice" maxlength="20" (input)="hasInputTextChanged(element, false);" autocomplete="new-username">
                      </mat-form-field>
                    </span>
                  </div>
                  <div class="col-2">
                    <span class="seller-name padding-r10" *ngIf="!IsShowTreatment(element)">Replant Date:</span>
                    <span class="text-center deliveryDatePicker" [ngClass]="{'handCursor': !readOnlyAccess }">
                      <mat-form-field>
                        <input id="txtReplantDate_{{element.itemNumber}}" matInput readonly [matDatepicker]="picker" [(ngModel)]="element.plantingDate" #dateName="ngModel" maxlength="12" [min]="getEffectiveInvoiceDate(true, element)" [max]="getEffectiveInvoiceDate(false, element)"
                               name="dateName" oninput="this.value=this.value.replace(/[^0-9/]/g,'');" (dateChange)="hasInputTextChanged(element, false)"
                               autocomplete="new-username" (click)="picker.open();" [ngClass]="{'handCursor': !readOnlyAccess }">
                        <mat-datepicker-toggle matSuffix [for]="picker" [readonly]="readOnlyAccess"></mat-datepicker-toggle>
                        <mat-datepicker #picker [disabled]="readOnlyAccess">
                        </mat-datepicker>
                      </mat-form-field>
                    </span>
                  </div>
                  <div class="col-2" [ngClass]="{'col-md-4': !IsShowTreatment(element) }">
                    <span class="customer-po text-left padding-r10" *ngIf="!IsShowTreatment(element)">
                      Grower License#:
                    </span>
                    <span class="customer-po-input" [ngClass]="{'padding-b5': IsShowTreatment(element) }">
                      {{element.licenseNumber}}
                      <!--<mat-form-field class="example-full-width">-->
                      <!--<input id="txtReplantLicenseNumber_{{element.itemNumber}}" matInput [readonly]="readOnlyAccess" type="text" [(ngModel)]="element.licenseNumber" maxlength="50" (input)="hasInputTextChanged(element, false);" autocomplete="new-username" [readonly]="vendersArr.includes(element.vendorName) && element.licenseStatus === 'L'">-->
                      <!--<input id="txtReplantLicenseNumber_{{element.itemNumber}}" matInput type="text" [(ngModel)]="element.licenseNumber" maxlength="50" (input)="hasInputTextChanged(element, false);" autocomplete="new-username" [readonly]="true">
              </mat-form-field>-->
                    </span>
                  </div>
                  <div class="col-2 material-select reason-dropdown treatment-dropdown margin-top-27" *ngIf="IsShowTreatment(element)">
                    <ng-select [items]="treatmentList"
                               class="change-dropdown"
                               [virtualScroll]="true"
                               [(ngModel)]="element.replantTreatment"
                               bindLabel="description"
                               bindValue="treatmentId"
                               appendTo=".failedTable"
                               [selectOnTab]="true"
                               [clearable]="false"
                               [searchable]="false"
                               [closeOnSelect]="true"
                               (change)="hasInputTextChanged(element, false);"
                               [attr.id]="'ddlReplantTreatment_' + element.itemNumber">
                      <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                        <div class="dropdown-template" [attr.id]="'ddlReplantTreatmentOpt_'+element.itemNumber+'_'+item.treatmentId">
                          <div class="row">
                            <div class="col-md-8">
                              <p class="name greenColor mb-0 treatmentFont" [ngOptionHighlight]="search">
                                {{item.description}}
                              </p>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </ng-select>
                  </div>
                  <div class="col-1" *ngIf="IsShowTreatment(element)">
                    <div class="customer-po-input inVoiceInput" [ngClass]="{'padding-b5': IsShowTreatment(element) }">
                      <mat-form-field class="example-full-width">
                        <input id="txtReplantOtherTreatment_{{element.itemNumber}}" matInput type="text" [(ngModel)]="element.otherTreatment" maxlength="30" (input)="hasInputTextChanged(element, false);" autocomplete="new-username">
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
              <div class="inline-error" *ngIf="isReview && element.lineErrors && element.lineErrors.errors.length > 0">
                <div class="row">
                  <div class="col-md-9">
                    <ol class="error-list">
                      <li *ngFor="let err of element.lineErrors.errors">
                        {{err.error}}
                    </ol>
                  </div>
                  <div class="col-md-3 revertToPrev" (click)="revertToPreviousErrorReplant(element, true)">
                    <span>
                      Revert to Previous.
                      <i class="icon-ico-Reply"></i>
                    </span>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="replantDisplayedColumns;sticky:true;"></tr>
          <tr mat-row *matRowDef="let element; columns: replantDisplayedColumns;"
              class="example-element-row"
              [class.example-expanded-row]="expandedElement === element"
              (click)="expandedElement = expandedElement === element ? null : element"></tr>
          <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
          </table>
          <div *ngIf="replantProductItemsDataSource == undefined || replantProductItemsDataSource?.data.length == 0" class="noDataMsg">
            <p>No Record Found.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="common-error-block new-return-request" *ngIf="isReview && showErrorBlock && errorMsgs.length>0 && errorMsgs[index]?.errors?.length > 0">
    <div class="row">
      <div class="col-md-2 padding-r0 errCountOuter">
        <span class="errorCounting">
          {{currentErrorRow}} of {{errorMsgs.length}}
        </span>
      </div>
      <div class="col-md-6 padding-l0 ">
        <ul class="errorMsg">
          <li *ngFor="let err of errorMsgs[index].errors">
            <p> {{err.error}}</p>
          </li>
        </ul>
      </div>
      <div class="col-md-4 button-sec text-right">
        <button mat-raised-button class="btns" color="primary" (click)="revertAllChanges()">Revert All Errors</button>
        <button mat-raised-button class="btns" color="primary" *ngIf="errorMsgs && errorMsgs.length>1" (click)="nextError()">Next Error</button>
      </div>
    </div>
  </div>
  <div *ngIf="!readOnlyAccess" class="SeedFulfillBtnSec">
    <div class="row padding-l20">
      <div class="col-md-12 mobile-footer" style="display: contents;">
        <button id="btnReviewRequest" mat-raised-button class="btns" [disabled]="!isReviewRequestEnable" (click)="saveDraft(true)">Review Request</button>
        <button id="btnSaveDraft" mat-raised-button class="btns" [disabled]="!isSaveOrderDraftEnable" color="primary" (click)="saveDraft(false)" [style.display]="'inline-block'">Save Draft</button>
      </div>
    </div>
  </div>
</div>
